/** Public standalone baker / froster calculator API (no manager auth). */

async function parseJson(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.detail || data?.message || "Request failed");
  }
  return data;
}

export async function fetchCalculatorFlavors() {
  const res = await fetch("/api/calculator/flavors");
  const data = await parseJson(res);
  return data.flavors || [];
}

export async function fetchBakerCalculator(params) {
  const q = new URLSearchParams();
  q.set("flavor", params.flavor);
  q.set("weight_kg", String(params.weightKg ?? 0.5));
  if (params.baseFlour) q.set("base_flour", params.baseFlour);
  if (params.sweetener) q.set("sweetener", params.sweetener);
  const res = await fetch(`/api/calculator/baker?${q.toString()}`);
  return parseJson(res);
}

export async function fetchFrosterCalculator(params) {
  const q = new URLSearchParams();
  q.set("flavor", params.flavor);
  q.set("weight_kg", String(params.weightKg ?? 0.5));
  q.set("order_type", params.orderType || "Custom");
  q.set("tiers", String(params.tiers ?? 0));
  q.set("quantity", String(params.quantity ?? 1));
  const res = await fetch(`/api/calculator/froster?${q.toString()}`);
  return parseJson(res);
}
